import { customElement } from 'lit/decorators.js'
import { html, css, LitElement } from 'lit'

@customElement('zaptic-ellipsis')
export class Ellipsis extends LitElement {
    static styles = css`
        :host {
            display: block;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }
    `

    render() {
        return html`<slot></slot>`
    }
}
